module.exports = __webpack_public_path__ + "img/15.58ecd261.png";